import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

/**
 * EN/PT language toggle. Persists choice via i18next localStorage detector.
 * Drop into Navbar.
 */
export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || "en";

  const change = (lng) => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    // Re-render any non-i18n strings that read i18n directly (defensive).
    document.documentElement.lang = lng;
  };

  return (
    <div className="inline-flex items-center gap-1 text-xs" data-testid="language-toggle">
      <Globe size={12} className="text-[#5A5F6A] mr-1" aria-hidden />
      <button
        type="button"
        onClick={() => change("en")}
        data-testid="lang-en"
        className={`px-2 py-1 transition-colors ${
          current === "en"
            ? "font-bold text-[#080808]"
            : "text-[#5A5F6A] hover:text-[#080808]"
        }`}
        aria-pressed={current === "en"}
      >
        EN
      </button>
      <span className="text-[#5A5F6A]">/</span>
      <button
        type="button"
        onClick={() => change("pt")}
        data-testid="lang-pt"
        className={`px-2 py-1 transition-colors ${
          current === "pt"
            ? "font-bold text-[#080808]"
            : "text-[#5A5F6A] hover:text-[#080808]"
        }`}
        aria-pressed={current === "pt"}
      >
        PT
      </button>
    </div>
  );
}
